export default __webpack_public_path__ + "static/media/runeofresistance.8bc8260e.png";